import styled from '@emotion/styled';

export const Wrapper = styled(`div`)`
  margin-bottom: 300px;

  .status-label {
    span {
      position: relative;
      display: inline-block;
      font-size: 10px;
      line-height: 1;
      padding: 0.25em 0.4em;
      border-radius: 0.25rem;
      font-weight: bold;
      text-align: center;
    }

    .color-new {
      background: rgb(108, 117, 125);
      color: rgb(255, 255, 255);
    }

    .color-signed-performer {
      background: rgb(79, 198, 225);
      color: rgb(255, 255, 255);
    }

    .color-signed-client,
    .color-approved-client,
    .color-approved-auto {
      background: rgb(26, 188, 156);
      color: rgb(255, 255, 255);
    }

    .color-not-approved {
      background: rgb(241, 85, 108);
      color: rgb(255, 255, 255);
    }

    .color-not-present {
      background: rgb(247, 184, 75);
      color: rgb(255, 255, 255);
    }
  }

  .edit-icon {
    cursor: pointer;
  }

  .card-body {
    background-color: white;
  }

  .title-cell,
  .client-cell {
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 767px) {
    margin: 0 -22px;

    .menu {
      display: none;
    }

    .settings {
      max-width: 100%;
    }

    .page-title-box {
      padding: 0 24px;
    }

    .card-box {
      width: 100%;
      border-radius: unset;
      box-shadow: none;
    }

    .col-6 {
      flex: 100%;
      max-width: 100%;
    }

    .mail-sending {
    }

    .btn.btn-danger {
      margin-top: 15px;
    }

    .feeds-wrapper {
      padding-top: 0 !important;
    }

    .promocodes-row {
      padding-bottom: 16px;
    }

    .row.justify-content-center {
      padding: 0 24px 24px;
    }
  }
`;

export const DocumentsTabsWrapper = styled('div')`
  .nav-tabs-orders {
    position: absolute;
    top: -14px;
  }

  .nav-tabs-orders .nav-item.show .nav-link,
  .nav-tabs-orders .nav-link.active {
    color: #7e57c2;
    background-color: #fff;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
  }

  .nav-tabs-orders .nav-link-after {
    content: '';

    left: 0px;
    width: 100%;
    height: 5px;
    background-color: #fff;
    border: none;
  }

  .nav-tabs-orders .nav-link-after {
    border-top: 1px solid #edf0f2;

    margin-top: -1px;
  }

  .nav-tabs-orders .nav-link-after.active {
    border-top: 0px;
    margin-top: 0px;
  }

  .nav-tabs-orders .nav-link.active .badge {
    background-color: #7e57c2;
    color: #fff;
  }

  .nav-tabs-orders .nav-link .badge {
    background-color: #dfe4e6;
    color: #828489;
    margin-left: 10px;
    font-weight: 600;
  }

  .nav-tabs-orders .nav-link .badge {
  }

  .nav-tabs-orders .nav-item {
    margin-right: 4px;
  }

  .nav-link-icon {
    display: none;
  }

  .nav-tabs-orders .nav-link {
    border: 1px solid transparent;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
    background-color: #fbfcfd;
  }

  .nav-tabs-orders .nav-link.active {
    border: 1px solid transparent;
  }

  .nav-tabs-orders .nav-link:hover {
    background-color: #fff;
  }

  .nav-tabs-orders > li > a {
    color: #7a7c82;
    font-weight: 600;
  }

  .nav-link {
    display: block;
    padding: 0.5rem 1rem;
    cursor: pointer;
  }

  .nav-link .nav-link-icon {
    padding-top: 1px;
    margin-right: 3px;
  }

  .nav-link i {
    font-size: 1rem;
    margin-right: 3px;
    margin-top: 4px;
  }

  @media (max-width: 520px) {
    .nav-link {
      padding-right: 5px;
      padding-left: 5px;
      .badge {
        display: none;
      }
    }
  }
`;

export const DocumentsCardWrapper = styled('div')`
  .fbm-title {
    font-size: 12px;
  }

  .card {
    margin-top: 38px;
    border-top-left-radius: 0px;
  }

  .form-wrapper {
    display: flex;

    form {
      flex-grow: 1;
    }
  }

  .tags-button {
    margin-bottom: 12px;
    margin-left: -12px;
    align-items: center;
    display: flex;
  }

  .tag-point {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-left: 3px;
  }

  .orders-search-group {
    position: relative;
    width: 100%;
  }

  .orders-search-group input {
    width: 100%;
  }

  .orders-search-group button {
    position: absolute;
    top: 5px;
    right: 5px;
  }

  .unpacking-button {
    &:focus {
      background-color: #f1f5f7;
      border-color: #f1f5f7;
      box-shadow: none !important;
    }
    .badge-pill {
      background-color: #7e57bf;
      color: #fff;
      font-weight: 600;
      margin-left: 5px;
    }
  }

  .shipping-button {
    .badge-pill {
      background-color: #fff;
      color: #1bbc9b;
      font-weight: 600;
      margin-left: 5px;
    }
  }

  .filters-row {
    display: flex;

    > div:last-child {
      padding-right: 0;
    }

    .extra-content {
      display: flex;

      .tags-button {
        margin-right: auto;
      }

      .unpacking-button {
        margin-left: 0 !important;
      }
    }
  }

  .reserved {
    padding: 5px 25px 5px 10px;
    background: #f5f5f5;
    border-radius: 5px;
    margin: 10px 0 0;
    position: relative;

    i {
      margin-left: 5px;
      position: absolute;
      top: 5px;
      right: 5px;
      cursor: pointer;
    }
  }

  .dropdown-wrapper {
    position: relative;
  }

  .reserve-icon {
    display: inline-block;
    background: #88c7eb;
    border-radius: 4px;
    padding: 0px 4px;
    margin-left: 5px;
    position: relative;
    i {
      color: white;
      font-weight: lighter;
      font-size: 12px;
    }
    &.unactive {
      background: #d6dbde;
    }
  }

  .reserve-tip {
    padding: 2px 6px;
    position: absolute;
    border: 1px solid #dee2e6;
    background: white;
    width: max-content;
    color: #7f828b;
    font-weight: normal;
    z-index: 2;
    left: -20px;
    top: 26px;
    font-size: 12px;
  }
`;

export const FilterWrapper = styled(`div`)`
  .dates-block {
    display: flex;

    .react-datepicker-wrapper {
      width: calc((100% - 25px) / 2);
    }

    .date-separator {
      width: 25px;
      text-align: center;
      font-size: 22px;
      font-weight: 600;
    }
  }
`;
